import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Section from "../../components/section";
import background from "../../assets/backgrounds/landing-5.svg";

// Logo imports
import logoAIC from "../../assets/partners/aic-logo.png";
import logoCiti from "../../assets/partners/citi logo.png";
import logoNYC from "../../assets/partners/NYC.png";
import logoTHK from "../../assets/partners/thk-logo.png";
import logoProductions from "../../assets/partners/productions-logo.png";
import logoSIC from "../../assets/partners/Social impact catalyst Logo.png";
import logoSpeech from "../../assets/partners/speech_therapy_adventures_logo.png";
import logoYAC from "../../assets/partners/YAC-logo.png";
import logoYEA from "../../assets/partners/yea-logo.png";
import logoBedok from "../../assets/partners/bedok-view-sec-school-logo.png";
import leo from "../../assets/partners/leo-logo.png";

const Partners: React.FC = () => {
  const logos = [
    { src: logoAIC, alt: "Agency for Integrated Care" },
    { src: logoCiti, alt: "Citi" },
    { src: logoNYC, alt: "National Youth Council" },
    { src: logoTHK, alt: "Thye Hua Kwan" },
    { src: logoProductions, alt: "Venka Productions" },
    { src: logoSIC, alt: "Social Impact Catalyst" },
    { src: logoSpeech, alt: "Speech Therapy Adventures" },
    { src: logoYAC, alt: "Youth Action Challenge" },
    { src: logoBedok, alt: "Bedok View Secondary School" },
    { src: logoYEA, alt: "Youth Empowerment Association" },
    { src: leo, alt: "Leo" },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    rows: 2,
    slidesPerRow: 1,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          rows: 2,
          slidesPerRow: 1,
        },
      },
    ],
  };

  return (
    <Section backgroundImage={background}>
      <div className="flex flex-col items-center justify-center h-screen">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl sm:text-5xl font-bold mb-8 text-center text-white">
            Backed by our <span className="text-[#0AFBF8]">partners</span>
          </h2>
          <div className="partners-carousel px-4">
            <Slider {...settings}>
              {logos.map((logo, index) => (
                <div key={index} className="px-4">
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className="h-20 sm:h-32 object-contain mx-auto"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Partners;
